// ------------------------------------------------
//
// Use Project Type List
// Returns a global shared reference to the project type list
//
// ------------------------------------------------


import { ref } from 'vue'


const listRef = ref([])


//
//  Curried set ref helper to be used with promises/fetch
//
function setRef(name) {
    return function(value) { name.value = value }
}


//
//  Load ProjectType list
//
import useAPI from '@/use/useAPI'
const { getData } = useAPI();
loadProjectTypeData()
export function loadProjectTypeData(){
    getData("/project_type/")
        .then(setRef(listRef))
        .catch((err) => console.log(err.message));
}




export default function useProjectTypeList(){
    //
    //  Return shared ProjectType list
    //
    return listRef
}